import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Form, Grid } from 'semantic-ui-react';

import { AERIES_PREVIEW_FORM_NAME } from 'Common/FormEnum';
import { InputMode } from 'Common/FormEnum';
import { InputField } from 'Common/SemanticWrapper';
import { AeriesFieldEnum } from 'Common/Constants/SISIntegration';

const AeriesPreviewStepFormContainer = (props) => {
  return (
    <Form name={AERIES_PREVIEW_FORM_NAME}>
      <Grid>
        <Grid.Row>
          <Grid.Column width={6}>
            <Field
              label={'Student Id'}
              name={AeriesFieldEnum.StudentId}
              component={InputField}
              disabled={props.loading}
              loading={props.loading}
              onKeyDown={props.handleKeyDown}
              mode={InputMode.Integer}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={6}>
            <Field
              label={'School Code'}
              name={AeriesFieldEnum.SchoolCode}
              component={InputField}
              disabled={props.loading}
              loading={props.loading}
              onKeyDown={props.handleKeyDown}
              mode={InputMode.Integer}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values[AeriesFieldEnum.StudentId]) {
    errors[AeriesFieldEnum.StudentId] = 'Student Id is required.';
  }

  if (!values[AeriesFieldEnum.SchoolCode]) {
    errors[AeriesFieldEnum.SchoolCode] = 'School Code is required.';
  }

  return errors;
};

export const AeriesPreviewStepForm = reduxForm({
  form: AERIES_PREVIEW_FORM_NAME,
  validate,
  enableReinitialize: true,
})(AeriesPreviewStepFormContainer);



// WEBPACK FOOTER //
// ./src/pages/aeriesintergration/components/AeriesPreviewStep/AeriesPreviewForm.js